<template>
    <div class="kanban-board-wrapper">
        <div
            v-if="productionLine && productionLine.hasOwnProperty('name')"
            :class="[ error?'board-header-error':'' ,'board-header']"
            v-b-toggle="[...(orderStateId == 3?[`${orderStateId}_${productionLine?productionLine.id:0}`]:[`4_${productionLine?productionLine.id:0}`,`2_${productionLine?productionLine.id:0}`]) ]"
        >
            <AlarmButton v-if="alarm && orderStateId !== 3 " :alarm="alarm" ></AlarmButton>
            <div class="title">{{ productionLine?productionLine.name:'' }}</div>
            <div class="state">{{ boardMessage }}</div>
        </div>
        <b-collapse
            :id="`${orderStateId}_${productionLine?productionLine.id:0}`"
            class="board-body"
            :visible="!productionLine"
        >
            <Draggable
                :id="`draggable_${orderStateId}_${productionLine?productionLine.id:0}`"
                class="list-group kanban-column board-pending"
                v-model="orderReferenceList"
                v-bind="dragOptions"
                :group="kanbanGroup"
                :disabled="!canDrag"
                draggable=".draggable-order-reference"
            >
                <transition-group class="list-group-item-wrapper" >
                    <ProductionOrderCard
                        :draggable="canDrag"
                        v-for="orderReference in orderReferenceList"
                        v-if="orderReference"
                        :orderReference="orderReference"
                        :key="orderReference.id"
                        :isThereOrInProductionAtProductionLine="isThereOrInProductionAtProductionLine"
                        :canOpenMenu="true"
                        :class="[orderReference.hasOwnProperty('placeholder')? 'order-reference-placeholder':'draggable-order-reference', 'list-group-item', canDrag ? '' : 'pointer']"
                        @toggleMenu="handleToggleMenu"
                    >
                    </ProductionOrderCard>
                </transition-group>
            </Draggable>
        </b-collapse>
    </div>
</template>

<script>
import Draggable from "vuedraggable";
import ProductionOrderCard from "./ProductionOrderCard";
import {mapActions, mapGetters} from "vuex";
import {OrderStates, ProductionControlModals} from "../utils";
import {FilterTypes} from "./FilterTypes";
import AlarmButton from "./AlarmButton";
import { showCustomSuccessSweetAlert } from "../../common/utils";
import PermissionConsts from "../../common/permissions";
import ProductionOrderCardMenu from "./ProductionOrderCardMenu/ProductionOrderCardMenu.vue";

export default {
    name: "KanbanBoard",
    components:{
        AlarmButton,
        Draggable,
        ProductionOrderCard,
        ProductionOrderCardMenu
    },
    props:{
        orderStateId: Number,
        productionLine:Object,
        dragOptions: Object,
        kanbanGroup: String
    },
    data(){
        return{
            listGroupHeight: 0,
            oldKanban: null,
            oldOrderReferencelist: null,
            nextOrder: null,
            showMenu: false,
            openMenuId: null,
        }
    },
    computed:{
        ...mapGetters('production_control',['orderReferencesByStateIdAndProductionLineId', 'orderReferencesByStateId', 'activeModals',
            'kanbanOrderReferences', 'kanbanOrderReferencesByStateIdAndProductionLineId','kanbanOrderReferencesInQueueByProductionLineId',
            'kanbanErrorByProductionLineId','kanbanAlarmByProductionLineId','filterByName','kanbanPendingOrderReferences','queueEditActive', 'isMenuShowing']),
        ...mapGetters(['userPermissions','userHasPermission']),
        canDrag(){
            return this.userHasPermission(PermissionConsts.PLANNER_QUEUE_ORDER_UPDATE) && this.validOrderStateToDrag && !this.isMenuShowing;
        },
        orderReferenceList:{
            get: function() {
                let self = this;

                let orderReferenceList = [];
                switch(self.orderStateId){
                    case OrderStates.QUEUED: orderReferenceList = self.productionLine? self.kanbanOrderReferencesInQueueByProductionLineId(self.productionLine.id):[];  break;
                    case OrderStates.PENDING: orderReferenceList = self.kanbanPendingOrderReferences; break;
                    default: orderReferenceList = self.kanbanOrderReferencesByStateIdAndProductionLineId(self.orderStateId, self.productionLine.id)
                }

                if (orderReferenceList.length) self.nextOrder = orderReferenceList[0];

                // FILTROS
                let referenceName = self.filterByName(FilterTypes.REFERENCES)
                if(referenceName && referenceName.length) orderReferenceList = orderReferenceList.filter(or => or?.reference.descrip.toLowerCase().includes(referenceName.toLowerCase()));

                let orderReferenceName = self.filterByName(FilterTypes.ORDER_REFERENCE)
                if(orderReferenceName && orderReferenceName.length) orderReferenceList = orderReferenceList.filter(or => or.descrip.includes(orderReferenceName));

                let batch = self.filterByName(FilterTypes.BATCH)
                if(batch && batch.length) orderReferenceList =  orderReferenceList.filter(or => or.batch && or.batch.toLowerCase().includes(batch.toLowerCase()));

                let client = self.filterByName(FilterTypes.CLIENT)
                if(client && client.length) orderReferenceList =  orderReferenceList.filter(or => {
                    if(!or.order || !or.order.client) return false;
                    let orClient = or.order.client;
                    return orClient.name.toLowerCase().includes(client.toLowerCase()) || 
                           orClient.nif.toLowerCase().includes(client.toLowerCase()) || 
                           orClient.business_name.toLowerCase().includes(client.toLowerCase()) ||
                           ( or.reference.brand && or.reference.brand.toLowerCase().includes(client.toLowerCase()) );
                });

                let cargoDate = self.filterByName(FilterTypes.CARGO_DATE)
                if(cargoDate && cargoDate.length) {
                    cargoDate = new Date(cargoDate)
                    orderReferenceList = orderReferenceList.filter(or => {
                        let orCargoDate = new Date(or.cargo_date);
                        return orCargoDate.getFullYear() > cargoDate.getFullYear() ||
                                ((orCargoDate.getFullYear() == cargoDate.getFullYear() && orCargoDate.getMonth() > cargoDate.getMonth()) 
                                    ||  (orCargoDate.getFullYear() == cargoDate.getFullYear() 
                                            && orCargoDate.getMonth() == cargoDate.getMonth() 
                                            && orCargoDate.getDate() >= cargoDate.getDate()));
                    } );
                }

                let order = self.filterByName(FilterTypes.ORDER)
                if(order && order.length){
                    orderReferenceList = orderReferenceList.sort((a,b) =>
                        ( order === 'asc'
                            ?   ((a.cargo_date > b.cargo_date) ? 1
                                : ((b.cargo_date > a.cargo_date) ? -1 : 0) )
                            :   ((a.cargo_date < b.cargo_date) ? 1
                                : ((b.cargo_date < a.cargo_date) ? -1 : 0) )
                        )
                    )
                }
                return orderReferenceList;
            },
            set: function(newValue) {
                if(!this.queueEditActive){
                    showCustomSuccessSweetAlert('Edición de colas activa')
                    this.setQueueEditActive(1);
                }

                let changes = this.orderReferenceList
                    .filter(x => !newValue.includes(x))
                    .concat(newValue.filter(x => !this.orderReferenceList.includes(x)));
                let changeType = this.orderReferenceList.length > newValue.length?'DELETE':'ADD'

                let change = null;
                if(changes.length > 1) return console.warn('Mas de 1 cambio a la vez, algo raro pasa');
                else if(changes.length > 0) change = changes[0];

                if(!change){
                    this.orderKanbanOrderReferences({kanbanOrderReferences: newValue,onQueue: this.orderStateId == OrderStates.QUEUED, productionLineId: this.productionLine?this.productionLine.id:0})
                    return console.warn('Sin cambio');
                }

                let newChangeIndex = newValue.findIndex(or => or.id == change.id)

                switch(changeType){
                    case 'ADD':
                        this.createKanbanOrderReference({kanbanOrderReference: change, onQueue: this.orderStateId == OrderStates.QUEUED, productionLineId: this.productionLine?this.productionLine.id:0, index: newChangeIndex })
                        break;
                    case 'DELETE':
                        this.deleteKanbanOrderReference({kanbanOrderReference: change, onQueue: this.orderStateId == OrderStates.QUEUED , productionLineId: this.productionLine?this.productionLine.id:0})
                        break;
                }
            }
        },
        error(){
            let self = this;
            return self.productionLine? this.kanbanErrorByProductionLineId(self.productionLine.id) : null;
        },
        alarm(){
            let self = this;
            return self.productionLine? this.kanbanAlarmByProductionLineId(self.productionLine.id) : null;
        },
        boardMessage(){
            let self = this;
            let msg = '';
            let defaultMsg = 'Sin datos de la siguiente orden';
            switch(self.orderStateId){
                case OrderStates.QUEUED: msg = self.nextOrder?`Siguiente orden prevista: ${self.nextOrder.theoretical_start_date??''}`:defaultMsg;  break;
                case OrderStates.IN_PRODUCTION: msg = self.nextOrder? `Finalizacion prevista: ${self.nextOrder.ideal_end_date}`:defaultMsg; break;
                default: msg = '';
            }
            msg = self.error? self.error.msg:msg;

            return msg; //TODO: Poner un mensaje adecuado
        },
        isThereOrInProductionAtProductionLine(){
            let self = this;
            if(!self.productionLine) return false;
            return self.productionLine? self.kanbanOrderReferencesByStateIdAndProductionLineId(OrderStates.IN_PRODUCTION, self.productionLine.id).length > 0: false;
        },
        validOrderStateToDrag() {
            return this.orderStateId == OrderStates.QUEUED || this.orderStateId == OrderStates.PENDING;
        }
    },
    mounted(){
        var self = this;
        window.kanbanOrderReferencesInQueueByProductionLineId = self.kanbanOrderReferencesInQueueByProductionLineId;
    },
    methods:{
        ...mapActions('production_control', ['changeActiveModalState', 'createKanbanOrderReference','deleteKanbanOrderReference','orderKanbanOrderReferences', 'setQueueEditActive']),
        openOrderReferenceView(orderReferenceId){
            this.changeActiveModalState({modal:ProductionControlModals.ORDER_REFERENCE_VIEW, data: orderReferenceId })
        },
        handleToggleMenu(orderReferenceId) {
            this.openMenuId = this.openMenuId == orderReferenceId ? null : orderReferenceId;
            console.log('handleToggleMenu', orderReferenceId, this.openMenuId);
        },
        closeMenu() {
            this.openMenuId = null;
        },
    }
}
</script>